<template>
    <Breadcrumbs main="Tabs" title="Bootstrap Tabs" />
    <div class="container-fluid">
        <div class="row">
            <simpleTabs />
            <iconTabs />
            <verticalTabs />
            <pillsTabs />
            <justifyTabs />
            <leftTabs />
            <materialTabs />
            <borderTabs />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const simpleTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/simpleTabs.vue"))
const iconTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/iconTabs.vue"))
const verticalTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/verticalTabs.vue"))
const pillsTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/pillsTabs.vue"))
const justifyTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/justifyTabs.vue"))
const leftTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/leftTabs.vue"))
const materialTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/materialTabs.vue"))
const borderTabs = defineAsyncComponent(() => import("@/components/theme/uikits/tabs/borderTabs.vue"))
</script>